import { render, staticRenderFns } from "./Placements.vue?vue&type=template&id=4a495fee"
import script from "./Placements.vue?vue&type=script&lang=js"
export * from "./Placements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports